import React, { useRef } from 'react';


import Hero from "../components/Hero";
import Features from "../components/Features";
import HowItWorks from "../components/HowItWorks";
import CTA from "../components/CTA";

const Home = () => {
  const featuresRef = useRef(null);

  const scrollToFeatures = () => {
    featuresRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div>
      <Hero />
      <HowItWorks />
      <Features ref={featuresRef} />
      <CTA onScrollToFeatures={scrollToFeatures} />
    </div>
  );
}

export default Home ;